import React from "react";

const Button = ({ name }) => {
  return (
    <>
      <div className="py-12 border-t border-gray-300">
      <button
        type="submit"
        className="w-full rounded-lg bg-red-clarin hover:bg-red-clarin-700 px-3 py-2 text-lg text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ">
        {name}
      </button>        
    </div>
    </>
  );
};

export default Button;
